import { combineReducers } from 'redux';

import { getType } from 'typesafe-actions';
import { actions } from '..';
import { parseStringDate } from '../../api';
import { Tweet, TweetReply } from '../../model';
import { Actions, StoreState } from '../types';
import { createSelector } from 'reselect';
import { isDefined } from '../../type-utils';
import produce from 'immer';
import { getCommandIdFromCommand } from '../../Components/CallPopup';
import createCachedSelector from 're-reselect';

interface TweetById {
  [id: string]: Tweet
}

function tweetById(state: TweetById = {}, action: Actions): TweetById {
  switch (action.type) {


    case getType(actions.removeCommand): {
      const newState = { ...state }
      delete newState[action.payload]
      return newState
    }

    case getType(actions.updateMediaCommand): {
      const { command } = action.payload
      if (command.ExtendedInfo.KEYS) {

        const id = getCommandIdFromCommand(command)
        if (command.CommandType === "SHUTDOWN") {
          const newState = { ...state }
          delete newState[id]
          return newState
        }

        if (command.ExtendedInfo.QueueItems && command.ExtendedInfo.Specific) {
          const userId = command.ExtendedInfo.Specific.UserId;
          const userScreenName = command.ExtendedInfo.Specific.UserScreenName;
          const userLocation = command.ExtendedInfo.Specific.UserLocation;
          const userFollowersCount = command.ExtendedInfo.Specific.UserFollowersCount;
          const userProfileImageUrl = command.ExtendedInfo.Specific.UserProfileImageUrl;
          const createdAtUtc = parseStringDate(command.ExtendedInfo.Specific.CreatedAtUtc);
          const subject = command.ExtendedInfo.QueueItems.Subject;
          const receivedBy = command && command.ExtendedInfo.Specific && command.ExtendedInfo.Specific.ReceivedBy

          if (!id || !userId || !userScreenName || !userLocation || !userFollowersCount
            || !userProfileImageUrl || !createdAtUtc || !subject || !receivedBy) break;

          const chat = state[id]
          if (!chat) {
            return {
              ...state,
              [id]: { tweeterId: id, userId, userScreenName, userLocation, userFollowersCount, userProfileImageUrl, createdAtUtc, subject, receivedBy } as Tweet,
            }
          }
        }
      }
      break;
    }

    case getType(actions.fetchTweetResponse): {
      const { tweet } = action.payload
      const t = state[tweet.tweeterId]
      if (!t) {
        return {
          ...state,
          [tweet.tweeterId]: tweet,
        }
      }
      break;
    }

    case getType(actions.sentTweet): {
      return produce(state, state => {
        const { originalTweeterId, text, tweeterId, extensionId } = action.payload
        const t = state[originalTweeterId]
        if (!t) return

        if (!t.replies) {
          t.replies = [{ tweetId: tweeterId, text: text, extensionId, createdAtUtc: Date.now() } as TweetReply]
        } else {
          t.replies = [...t.replies, { tweetId: tweeterId, text: text, extensionId, createdAtUtc: Date.now() } as TweetReply]
        }
      })
    }

    case getType(actions.removeMediaItem): {
      const emails = state[action.payload]
      if (!emails) { return state }

      const { [action.payload]: _, ...rest } = state
      return rest
    }

    default:
      return state
  }
  return state
}

export default combineReducers({
  tweetById,
})

function getRoot(state: StoreState) { return state.twitter }
function getTweetsById(state: StoreState) { return getRoot(state).tweetById }

export function getTweetById(state: StoreState, id: string) {
  return getTweetsById(state)[id]
}

export const selectTweets = createSelector(
  getTweetsById,
  tweets => {
    return Object.values(tweets).filter(isDefined)
  },
)

export const selectTweetByReply = createCachedSelector(
  selectTweets,
  (s: StoreState, tweetId: string) => tweetId,
  (tweets, tweetId) => {
    for (const t of tweets) {
      if (t.replies && t.replies.find(r => r.tweetId === tweetId)) {
        return t
      }
    }
    return null
  },
)(
  (s, tweetId) => tweetId,
)
